(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-utils/assets/react/components/pin-icon.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-utils/assets/react/components/pin-icon.js');

'use strict';

const {
  pinPath,
  getColor
} = svs.tur.lyckoplatsen.map;
const PinIcon = _ref => {
  let {
    className,
    color = 'blue',
    useSmallIcon = false
  } = _ref;
  const finalColor = getColor(color);
  return React.createElement("span", {
    className: className
  }, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: useSmallIcon ? 30 : 54,
    height: useSmallIcon ? 44 : 80,
    viewBox: "0 0 54 80",
    fill: "none"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: pinPath,
    fill: finalColor
  })));
};
setGlobal('svs.lyckoplatsen.shared_utils.react.components', {
  PinIcon
});

 })(window);